const __WEBPACK_NAMESPACE_OBJECT__ = require("bootstrap/dist/css/bootstrap.min.css");